import React from 'react';
import PropTypes from 'prop-types';

import YoutubeViewer from 'react-youtube';
import { FormattedMessage } from 'react-intl';

import { reportEventToAnalytics } from '../../../../infrastructure/utilities/analyticsOperations';

const SinglePublicationVideoContent = ({ videoSrc, title }) =>
{
    if (videoSrc)
    {
        return (
            <>
                <h3><FormattedMessage id="video_content"/></h3>
                <YoutubeViewer
                    className="video-viewer"
                    opts={{
                        width: '100%',
                        height: '100%',
                    }}
                    videoId={videoSrc}
                    onPlay={reportEventToAnalytics({
                        category: 'Media Consumption',
                        action: 'Played video from ' + title,
                    })}
                />
            </>
        );
    }

    return null;
};

SinglePublicationVideoContent.propTypes = {
    mediaTypes: PropTypes.object,
    videoSrc: PropTypes.string,
    title: PropTypes.string,
};

export default SinglePublicationVideoContent;
